import { Color, Vector2 } from 'three';
export const TEXTURE_PARAM_NAMES = [
    'map',
    'metalnessMap',
    'roughnessMap',
    'alphaMap',
    'aoMap',
    'bumpMap',
    'displacementMap',
    'emissiveMap',
    'envMap',
    'lightMap',
    'normalMap',
];
const textureParams = TEXTURE_PARAM_NAMES.reduce((acc, name) => {
    acc[name] = { kind: 'texture', requiresNeedsUpdateOnChange: true };
    return acc;
}, {});
export const BASE_MATERIAL_SCHEMA = {
    transparent: { kind: 'boolean', requiresNeedsUpdateOnChange: true },
    depthTest: { kind: 'boolean', requiresNeedsUpdateOnChange: true },
    depthWrite: { kind: 'boolean', requiresNeedsUpdateOnChange: true },
    polygonOffset: { kind: 'boolean', requiresNeedsUpdateOnChange: false },
    dithering: { kind: 'boolean', requiresNeedsUpdateOnChange: true },
    fog: { kind: 'boolean', requiresNeedsUpdateOnChange: true },
    flatShading: { kind: 'boolean', requiresNeedsUpdateOnChange: true },
    wireframe: { kind: 'boolean', requiresNeedsUpdateOnChange: true },
    toneMapped: { kind: 'boolean', requiresNeedsUpdateOnChange: true },
    premultipliedAlpha: { kind: 'boolean', requiresNeedsUpdateOnChange: true },
    clipIntersection: { kind: 'boolean', requiresNeedsUpdateOnChange: true },
    clipShadows: { kind: 'boolean', requiresNeedsUpdateOnChange: true },
    opacity: { kind: 'number', requiresNeedsUpdateOnChange: false },
    alphaTest: { kind: 'number', requiresNeedsUpdateOnChange: true },
    polygonOffsetFactor: { kind: 'number', requiresNeedsUpdateOnChange: false },
    polygonOffsetUnits: { kind: 'number', requiresNeedsUpdateOnChange: false },
    side: { kind: 'number', requiresNeedsUpdateOnChange: true },
    shadowSide: { kind: 'number', requiresNeedsUpdateOnChange: true },
    blending: { kind: 'number', requiresNeedsUpdateOnChange: true },
    normalMapType: { kind: 'number', requiresNeedsUpdateOnChange: true },
};
export const STANDARD_MATERIAL_SCHEMA = Object.assign({ color: { kind: 'color', requiresNeedsUpdateOnChange: false }, metalness: { kind: 'number', requiresNeedsUpdateOnChange: false }, roughness: { kind: 'number', requiresNeedsUpdateOnChange: false }, normalScale: { kind: 'vector2', requiresNeedsUpdateOnChange: false }, emissive: { kind: 'color', requiresNeedsUpdateOnChange: false }, emissiveIntensity: { kind: 'number', requiresNeedsUpdateOnChange: false }, aoMapIntensity: { kind: 'number', requiresNeedsUpdateOnChange: false }, lightMapIntensity: { kind: 'number', requiresNeedsUpdateOnChange: false }, bumpScale: { kind: 'number', requiresNeedsUpdateOnChange: false }, displacementScale: { kind: 'number', requiresNeedsUpdateOnChange: false }, displacementBias: { kind: 'number', requiresNeedsUpdateOnChange: false }, envMapIntensity: { kind: 'number', requiresNeedsUpdateOnChange: false } }, textureParams);
export const PHYSICAL_MATERIAL_SCHEMA = Object.assign(Object.assign({}, STANDARD_MATERIAL_SCHEMA), { clearcoat: { kind: 'number', requiresNeedsUpdateOnChange: false }, clearcoatRoughness: { kind: 'number', requiresNeedsUpdateOnChange: false }, clearcoatNormalScale: { kind: 'vector2', requiresNeedsUpdateOnChange: false }, ior: { kind: 'number', requiresNeedsUpdateOnChange: true }, transmission: { kind: 'number', requiresNeedsUpdateOnChange: true }, thickness: { kind: 'number', requiresNeedsUpdateOnChange: false }, attenuationDistance: { kind: 'number', requiresNeedsUpdateOnChange: false }, attenuationColor: { kind: 'color', requiresNeedsUpdateOnChange: false }, specularIntensity: { kind: 'number', requiresNeedsUpdateOnChange: false }, specularColor: { kind: 'color', requiresNeedsUpdateOnChange: false }, sheenColor: { kind: 'color', requiresNeedsUpdateOnChange: false }, sheenRoughness: { kind: 'number', requiresNeedsUpdateOnChange: false }, clearcoatMap: { kind: 'texture', requiresNeedsUpdateOnChange: true }, clearcoatNormalMap: { kind: 'texture', requiresNeedsUpdateOnChange: true }, clearcoatRoughnessMap: { kind: 'texture', requiresNeedsUpdateOnChange: true }, transmissionMap: { kind: 'texture', requiresNeedsUpdateOnChange: true }, thicknessMap: { kind: 'texture', requiresNeedsUpdateOnChange: true } });
export const SHADER_MATERIAL_SCHEMA = {
    transparent: { kind: 'boolean', requiresNeedsUpdateOnChange: true },
};
export function getSchemaFor(type) {
    switch (type) {
        case 'standardMaterial':
            return Object.assign(Object.assign({}, BASE_MATERIAL_SCHEMA), STANDARD_MATERIAL_SCHEMA);
        case 'physicalMaterial':
            return Object.assign(Object.assign({}, BASE_MATERIAL_SCHEMA), PHYSICAL_MATERIAL_SCHEMA);
        case 'shaderMaterial':
            return Object.assign(Object.assign({}, BASE_MATERIAL_SCHEMA), SHADER_MATERIAL_SCHEMA);
        default:
            return {};
    }
}
export function convertValue(kind, value, assetsManager) {
    if (value === undefined || value === null)
        return value;
    switch (kind) {
        case 'color':
            return new Color(value);
        case 'texture':
            return assetsManager.getAsset(value);
        case 'vector2':
            if (value instanceof Vector2)
                return value;
            if (Array.isArray(value))
                return new Vector2(value[0], value[1]);
            if (typeof value === 'object')
                return new Vector2(value.x, value.y);
            return value;
        default:
            return value;
    }
}
//# sourceMappingURL=MaterialSchema.js.map